export function readMoreSidebar() {
  const sidebars = document.querySelectorAll(".read-more-sidebar");
  if (!sidebars.length) return;

  sidebars.forEach((sidebar) => {
    const entryId = sidebar.id.replace("read-more-sidebar-", "");
    const trigger = document.getElementById(entryId);
    const outer = sidebar.querySelector(".read-more-sidebar__outer");
    const closeButton = sidebar.querySelector(".read-more-sidebar__close-button");
    if (!trigger) return;

    function open() {
      sidebar.classList.add("is-open");
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    }

    function close() {
      sidebar.classList.remove("is-open");
      document.body.removeAttribute("style");
    }

    trigger.addEventListener("click", open);
    closeButton?.addEventListener("click", close);

    // Close on backdrop click
    sidebar.addEventListener("click", (e) => {
      if (!outer.contains(e.target)) {
        close();
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && sidebar.classList.contains("is-open")) {
        close();
      }
    });
  });
}
